import { Navigate, useSearchParams } from 'react-router-dom';
import { appConfig } from 'shared/appConfig';
import { useOnboardingStore } from 'shared/hooks/stores/useOnboardingStore';
import { useSitemap } from 'shared/hooks/useSitemap';

export const RedirectFromQueryToJobOrder = () => {
  const [searchParams] = useSearchParams();
  const jobOrderId = searchParams.get('jobOrderId');
  const sitemap = useSitemap();
  const onboardingFinishedAt = useOnboardingStore((state) => state.finishedAt);

  if (
    jobOrderId &&
    onboardingFinishedAt &&
    !appConfig.allowUserWithFinishedOnboardingBackToOnboarding
  ) {
    return <Navigate to={sitemap.jobOrder(jobOrderId)} replace />;
  }

  return null;
};
